import React, { Component } from "react";
import {
  img_url11,
  img_url12,
  img_url13,
  img_url14,
} from "../Constant/Constants";

export class Viewallblog extends Component {
  render() {
    return (
      <>
        <div className="blog_main_div_view">
          <div className="blog_img_div_view">
            <div className="blog_single_img_view">
              <img className="blog_img_view" src={img_url11}></img>
              <h2 class="blog_god_name_view">Lord Shiva</h2>
              <p className="blog_god_details_view">
                The Sanatan Dharma that is far from the confinement of time also
                boasts of timeless cosmic characters who spent a predetermined
                time on the face of the earth. Their sojourn on earth mostly
                have tales of eradication of sin, teaching and practicing
                benevolence, and of course helping the meek and weak. Maharishi
                Ved Vyas, who is credited to have compiled/edited/composed
                Vedas, Mahabharata, Shrimad Bhagwat Gita and all the Puranas and
                Mahapurans, included illustrations in his writings about these
                Hindu gods and goddesses that blessed the earth with their
                presence. Although Ved Vyas enlisted about millions of celestial
                beings in Hindu Sanatan Dharm, there remain some gods and
                goddess, who left an indelible mark on the heart of the sinful
                human race.
              </p>
            </div>
            <div className="blog_single_img_view">
              <img className="blog_img_view" src={img_url12}></img>
              <h2 class="blog_god_name_view">Lord Brahma</h2>
              <p className="blog_god_details_view">
                The Rig-Veda explains the concept of Brahma as a word that was
                used for deciphering a sacred mysterious power that helped
                create the world. In one amongst the many legends of Hindu
                Mythology, Brahma has been said to have been born of a golden
                egg that the Supreme Soul and Self-Existent Lord created by
                depositing water of the earth in a seed. Another text says that
                Brahma became a boar who raised the earth from the waters, and
                thus, created the world. He is also described as a fish or a
                tortoise at the beginning of the ages. Brahma is also believed
                to have been born from a lotus springing from the navel of
                another popular Hindu God, Vishnu. Lord Brahma is said to have
                four faces that represent the four Vedas; and he has four hands
                that represent the four directions, each of the hand holds one
                object like a rosary (mala), a water-pot (kamandal), a book (the
                Vedas), and a lotus. It is believed that the rosary that he
                carries represent eternal time, whereas, the water-pot denotes
                that the world was created by water. Lord Brahma can be seen
                seated on a large lotus and is reckoned to use a swan as his
                vehicle. It is to be noted that swan is a symbol of knowledge.
                Famous Brahma Temples in India: There are few temples that are
                dedicated to Lord Brahma in India. One temple is in Pushkar
                Rajasthan, others are Brahma Temple in Kumbakonam Tamil Nadu,
                Chaturmukha Brahma temple in Chebrolu, Andhra Pradesh,
                Brahmapureeswarar Temple in Thirupattur in Thiruchirapalli,
                Tamil Nadu and Thirunavaya in Kerala.
              </p>
            </div>
            <div className="blog_single_img_view">
              <img className="blog_img_view" src={img_url13}></img>
              <h2 class="blog_god_name_view">Lord Vishnu</h2>
              <p className="blog_god_details_view">
                Lord Vishnu, in Hindu Mythology, is reckoned to have been vested
                with the quality of permanence, continuity, and preservation. In
                the Rig Veda, Vishnu, is associated with Sun. He is also
                believed to be the essential part of the Trinity, i.e. Brahma,
                Vishnu, Mahesh. However, he has been recognized as God with
                numerous incarnations including the popular ones that of Lord
                Rama and Lord Krishna. He also took on the attributes of several
                deities in varied forms of animals like fish (Matsya), tortoise
                (Kurma), and the boar (Varaha); and eventually these diverse
                elements were reduced to the group of twenty-four Vishnu
                incarnations. The Man-Lion (Narasimha), the Dwarf (Vamana),
                Parashurama, Rama and Krishna along with the aforementioned ones
                were the major incarnations of Lord Vishnu. Lord Vishnu is blue
                in color and is believed to have four or more hands. He is
                dressed in yellow attire and is shown holding a wheel that
                represents the Universal Mind and the powers of creation and
                destruction; and a conch-shell, which is said to be associated
                with the inception of existence through its spiral form and its
                connection with water. This popular Hindu God is also seen
                holding the club which denotes authority or the strength of
                wisdom as the essence of life. The vehicle of Vishnu is
                Garuda/eagle, which is reckoned to be half-man and half-bird.
              </p>
            </div>
            <div className="blog_single_img_view">
              <img className="blog_img_view" src={img_url14}></img>
              <h2 class="blog_god_name_view">Goddess Lakshmi</h2>
              <p className="blog_god_details_view">
                A symbol of beauty, fertility, and auspiciousness, Goddess
                Lakshmi remain an important Hindu mythological character.
                Reckoned to be the provider of wealth, she is said to be the
                daughter of Sage Bhrigu and consort of Lord Vishnu. One of the
                mythological stories confirms that this Hindu Goddess
                resurrected to life during the epic churning of the ocean. An
                ardent devotee of Lord Shiva, the goddess is also associated
                with God Kuber and Indra. Her other names include Manushri,
                Chakrika, Kamalika, Aishwarya, Lalima, Kalyani, Nandika, Rujula,
                Vaishnavi, Samruddhi, Narayani, Bhargavi, Sridevi, Chanchala,
                Jalaja, Madhavi, Sujata, Shreya. Also, she has been referred to
                as Jaganmaatha or the Mother of the Universe in Shri Mahalakshmi
                Ashtakam. The much revered Hindu Goddess, Lakshmi has four hands
                (when sown individually), however, only hands of her are shown
                when she with Vishnu. A lotus in each of her upper hands; gold
                coins dropping down from the palms of her lower two hands can be
                seen in many of her illustrations. She is also depicted in
                golden colour and seated or standing on a lotus with two
                elephants, partially submerged in water, one on each side.
                Important Lakshmi Festivals: Vasant Navratri, Navaratri
              </p>
            </div>
            {/* <div className="blog_single_img">
              <img className="blog_img" src=""></img>
            </div>
            <div className="blog_single_img">
              <img className="blog_img" src=""></img>
            </div>
            <div className="blog_single_img">
              <img className="blog_img" src=""></img>
            </div>
            <div className="blog_single_img">
              <img className="blog_img" src=""></img>
            </div> */}
          </div>
        </div>
      </>
    );
  }
}

export default Viewallblog;
